import { AfterViewInit, Component, ElementRef, Inject, Input, Renderer2, ViewChild } from '@angular/core';

import { ShellHeightToken } from '../shared/constants/shell-height.token';
import { DocumentService } from '../shared/services/document.service';
import { WindowService } from '../shared/services/window.service';
import { ContextService } from '../shared/shared-context/context.service';

@Component({
    selector: 'ohp-feature-tooltip',
    templateUrl: './feature-tooltip.component.html'
})
export class FeatureTooltipComponent implements AfterViewInit {

    @Input() public text: string;

    @Input() public selector: ElementRef;

    @ViewChild('featureTooltip') public featureTooltip: ElementRef;

    private static readonly tooltipStyleId = 'tooltipStyles';
    private static readonly tooltipTopArrowOffset = 10;
    private static readonly tooltipWidth = 330;
    private static readonly maxArrowDisplacement = 250;

    constructor(
        @Inject(ShellHeightToken) private readonly shellHeight,
        private readonly contextService: ContextService,
        private readonly documentService: DocumentService,
        private readonly renderer: Renderer2,
        private readonly windowService: WindowService
    ) {
    }

    public ngAfterViewInit() {
        if (this.selector.nativeElement) {
            const rect = this.selector.nativeElement.getBoundingClientRect();
            const offset = this.documentService.getOffset(this.selector);
            const top = (offset.top + this.documentService.nativeDocument.querySelector('#officeHome__scroll-content').scrollTop + this.selector.nativeElement.clientHeight - this.shellHeight + FeatureTooltipComponent.tooltipTopArrowOffset) + 'px';
            this.renderer.setStyle(this.featureTooltip.nativeElement, 'top', top);

            const tooltipHorizontalStartPosition = this.contextService.isRtl ? this.windowService.innerWidth - offset.left - (rect.width / 2) : offset.left + (rect.width / 2);
            const furthestStartPosition = this.windowService.innerWidth - FeatureTooltipComponent.tooltipWidth;
            const tooltipHorizontalPosition = Math.max(0, Math.min(furthestStartPosition, (tooltipHorizontalStartPosition - FeatureTooltipComponent.tooltipWidth / 2)));
            this.renderer.setStyle(this.featureTooltip.nativeElement, this.contextService.isRtl ? 'right' : 'left', tooltipHorizontalPosition + 'px');

            let arrowDisplacement = 0;
            // If we adjusted the callout so that it would fit on the screen, we must reposition the arrow to still point to the same place
            if (tooltipHorizontalPosition === 0 || tooltipHorizontalPosition === furthestStartPosition) {
                const calculatedArrowDisplacement = 2 * (tooltipHorizontalStartPosition - tooltipHorizontalPosition) - FeatureTooltipComponent.tooltipWidth;
                arrowDisplacement = Math.max(-FeatureTooltipComponent.maxArrowDisplacement, Math.min(FeatureTooltipComponent.maxArrowDisplacement, calculatedArrowDisplacement));
            }

            // Pseudo-elements cannot have their CSS directly manipulated by jQuery, so we have to add a style sheet to manipulate their styles
            const tooltipArrowSelector = '.feature-tooltip.officeHome-callout--arrowTop:before,.officeHome-callout.officeHome-callout--arrowTop:after';
            const tooltipStyle = `${tooltipArrowSelector}{${this.contextService.isRtl ? 'right' : 'left'}:${arrowDisplacement}px;}`;
            this.documentService.addOrUpdateStyleTag(FeatureTooltipComponent.tooltipStyleId, tooltipStyle);
        }
    }
}
